import { User } from 'config/users'

export enum NOTIFICATION_TYPE {
  TASK = 'TASK',
  INFO = 'INFO',
}

export enum NOTIFICATION_STATUS {
  DISMISSED = 'DISMISSED',
  UNREAD = 'UNREAD',
  READ = 'READ',
}

export type INFO_CONTACT_CHANGES_EMAIL = {
  contactId: string
  corporationId: string
}

export type INFO_CONTACT_EDIT_INFO = {
  contactId: string
  corporationInfoId?: string
  corporationId: string
}

export type INFO_NEW_CORPORATION_ADMIN_ROLE = {
  contactId: string
  corporationId: string
}

export type INFO_NEW_LAW_FIRM_ADMIN_ROLE = {
  contactId: string
  lawFirmId: string
}

export type INFO_NEW_PORTFOLIO_ROLE = {
  contactId: string
  portfolioId: string
}

export type INFO_COMMUNICATION_RECEIVED = {
  communicationId: string
}

export type INFO_MEETING_CANCELLATION = {
  meetingId: string
  meetingAttendeeId: string
  mailTitle: string
  mailBody: string
  reasonForCancellation?: string
  meetingName: string
  meetingDate: string
}

export type INFO_EXPIRED_POOL = {
  corporationId: string
  poolId: string
  poolName: string
  expiresAt: string
}

export type INFO_RESPONSE_TO_MEETING = {
  meetingAttendeeId: string
  meetingName: string
}

export type TASK_INVITATION_TO_MEETING = {
  meetingId: string
  meetingAttendeeId: string
}

export type TASK_PROCEDURE_TO_SIGN = {
  procedureId: string
  companyMessage?: string | null
  isOwnAccount?: boolean
}

export type TASK_PROCEDURE_TO_SIGN_REPRESENTATIVE = {
  procedureId: string
}

export type INFO_NEW_TRANSACTION_EVENT = {
  contactId: string
  corporationId: string
  accountId: string
  companyMessage: string | null
  isOwnAccount: boolean
}

export enum NOTIFICATION {
  INFO_CONTACT_CHANGES_EMAIL = 'INFO_CONTACT_CHANGES_EMAIL',
  INFO_CONTACT_EDIT_INFO = 'INFO_CONTACT_EDIT_INFO',
  INFO_COMMUNICATION_RECEIVED = 'INFO_COMMUNICATION_RECEIVED',
  INFO_MEETING_CANCELLATION = 'INFO_MEETING_CANCELLATION',
  INFO_NEW_CORPORATION_ADMIN_ROLE = 'INFO_NEW_CORPORATION_ADMIN_ROLE',
  INFO_NEW_LAW_FIRM_ADMIN_ROLE = 'INFO_NEW_LAW_FIRM_ADMIN_ROLE',
  INFO_NEW_PORTFOLIO_ROLE = 'INFO_NEW_PORTFOLIO_ROLE',
  INFO_POOL_EXPIRATION = 'INFO_POOL_EXPIRATION',
  INFO_RESPONSE_TO_MEETING = 'INFO_RESPONSE_TO_MEETING',
  TASK_INVITATION_TO_MEETING = 'TASK_INVITATION_TO_MEETING',
  TASK_PROCEDURE_TO_SIGN = 'TASK_PROCEDURE_TO_SIGN',
  TASK_PROCEDURE_TO_SIGN_REPRESENTATIVE = 'TASK_PROCEDURE_TO_SIGN_REPRESENTATIVE',
  INFO_NEW_TRANSACTION_EVENT = 'INFO_NEW_TRANSACTION_EVENT',
}

export type NotificationGroup = {
  id: string
  notifications: Notification[]
  slug: NOTIFICATION
  user: User
  status: NOTIFICATION_STATUS
  progress: number
  createdAt: string
}

export type Notification = {
  id: string
  data:
    | INFO_MEETING_CANCELLATION
    | INFO_NEW_CORPORATION_ADMIN_ROLE
    | INFO_COMMUNICATION_RECEIVED
    | INFO_NEW_LAW_FIRM_ADMIN_ROLE
    | INFO_NEW_PORTFOLIO_ROLE
    | INFO_EXPIRED_POOL
    | INFO_RESPONSE_TO_MEETING
    | TASK_INVITATION_TO_MEETING
    | TASK_PROCEDURE_TO_SIGN
    | TASK_PROCEDURE_TO_SIGN_REPRESENTATIVE
    | INFO_CONTACT_EDIT_INFO
    | INFO_CONTACT_CHANGES_EMAIL
    | INFO_NEW_TRANSACTION_EVENT
  status: NOTIFICATION_STATUS
}
